// Mirrors the rows in the JoNoteType table. Id column is varchar(60); a new
// code needs a seed row (Database/Changes/) in the target database before the
// server deploys, because JoNote.JoNoteTypeId is an FK to that table.
// Keep in lock-step with the server-side JoNoteTypeCode helper in
// UniformaxPersistenceManager.cs.
export enum JoNoteTypeCode {
  Other	          = 'Other',
  PodNote         = 'PodNote',
  DetailCancelled = 'DetailCancelled',
  DetailUncancel  = 'DetailUncancel',
  HeaderCancelled = 'HeaderCancelled',
  ReturnRequested = 'ReturnRequested',
  ReturnReceived  = 'ReturnReceived',
  RestockCharged  = 'RestockCharged',
  RestockWaived   = 'RestockWaived',
  ReissueQtySet   = 'ReissueQtySet',
  CreditMemo      = 'CreditMemo',

  // v2 return-pipeline codes.
  ReturnInspected    = 'ReturnInspected',
  ReturnRouted       = 'ReturnRouted',
  ReturnSettled      = 'ReturnSettled',
  ReturnUnreconciled = 'ReturnUnreconciled',
  ReturnReconciled   = 'ReturnReconciled',
  ReturnRecovered    = 'ReturnRecovered',
  CreditMemoCreated  = 'CreditMemoCreated',

  // In-flight order-changes (Phase 1) — see docs/in-flight-order-changes.md.
  ItemDetailAllocated                     = 'ItemDetailAllocated',
  SubstitutionAccepted                    = 'SubstitutionAccepted',
  ItemDetailReleasedToInventory           = 'ItemDetailReleasedToInventory',
  ItemDetailFlaggedMisShipped             = 'ItemDetailFlaggedMisShipped',
  PoCancelRequested                       = 'PoCancelRequested',
  PoCancelDefinitive                      = 'PoCancelDefinitive',
  PoDetailAdded                           = 'PoDetailAdded',
  ItemArrivedAsUnallocatedStockPostCancel = 'ItemArrivedAsUnallocatedStockPostCancel',
  ItemArrivedManufacturerOvershipped      = 'ItemArrivedManufacturerOvershipped',
  PoDetailReducedPrePost                  = 'PoDetailReducedPrePost',
  PoDetailDeletedPrePost                  = 'PoDetailDeletedPrePost',
  ItemDetailReassignedOut                 = 'ItemDetailReassignedOut',

  // Post-submission repair of account-owned inventory settings.
  AccountInventoryEnabled = 'AccountInventoryEnabled',

  // Automatic close: every line shipped or cancelled, every invoice posted (server CloseJoHeaders).
  HeaderClosed = 'HeaderClosed',

  // Order changes noted by the server's AddOrderChangeNotes (Breeze saves) and the Proximity cancel import.
  HeaderStatusChanged = 'HeaderStatusChanged',
  PullBatchChanged    = 'PullBatchChanged',
  ShipDateChanged     = 'ShipDateChanged',
  ItemDetailRemoved   = 'ItemDetailRemoved',
  PoDetailChanged     = 'PoDetailChanged',
  InvoiceChanged      = 'InvoiceChanged',
}
